import { getClinicStructuredData } from "./clinic";

export function getBrooklynHeightsStructuredData() {
  return getClinicStructuredData("brooklyn", [
    { name: "Locations", path: "/locations/" },
    { name: "New York", path: "/locations/new-york/" },
    { name: "Brooklyn Heights", path: "/locations/new-york/brooklyn-heights/" },
  ]);
}
